import React from 'react';
import { CheckCircle, Clock, AlertCircle, MessageSquare } from 'lucide-react';

export function RecentActivityItem({ action, description, time, status }) {
  const getStatusIcon = () => {
    switch (status) {
      case 'completed':
        return <CheckCircle size={20} className="text-[#16A34A]" />;
      case 'pending':
        return <AlertCircle size={20} className="text-[#F59E0B]" />;
      case 'scheduled':
        return <Clock size={20} className="text-[#3498DB]" />;
      case 'message':
        return <MessageSquare size={20} className="text-[#06B6D4]" />;
      default:
        return <Clock size={20} className="text-[#7F8C8D]" />;
    }
  };

  return (
    <div className="flex items-start gap-3 p-3 hover:bg-gray-50 rounded-lg transition-colors">
      <div className="flex-shrink-0 mt-0.5">
        {getStatusIcon()}
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-[#2C3E50] text-sm">{action}</h4>
        <p className="text-sm text-[#7F8C8D]">{description}</p>
        <p className="text-xs text-[#7F8C8D] mt-1">{time}</p>
      </div>
    </div>
  );
}

export default RecentActivityItem;
